<template>
    <div>
        <Header />
        <div class="wrapper">
            <div class="main">

                <el-card class="box-card">
                    <div class="box-card-content">
                        <div class="box-card-avatar">
                            <el-avatar :size="50" :src="circleUrl"></el-avatar>
                            <div v-for="size in sizeList" :key="size">
                                <el-avatar :size="size" :src="circleUrl"></el-avatar>
                            </div>
                        </div>
                        <div class="box-card-username">{{ this.user.username }}</div>
                    </div>
                </el-card>

                <br>
                
                <el-card class="box-card">
                    <p class="box-card-heading">種別</p>
                    <div class="box-card-text" v-if="this.user.is_reach === 0">無料会員</div>
                    <div class="box-card-text" v-else-if="this.user.is_reach === 1"><font color="#E6A23C"><i class="el-icon-medal"></i></font> 有料会員</div>
                    <br>
                    <p class="box-card-heading">メールアドレス</p>
                    <div class="box-card-text">{{ this.user.email }}</div>
                </el-card>

                <div class="dialog" v-if="this.user.is_reach === 1">
                    ご解約は
                    <el-button type="text" @click="dialogVisible = true">こちら</el-button>
                    <div class="dialog-content">
                    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
                        <span>
                            本当に解約しますか？<br>
                            解約手続き後、即時に無料会員になります。
                        </span>
                        <span slot="footer">
                            <el-button @click="dialogVisible = false">キャンセル</el-button>
                            <el-button type="primary" @click="cancel">解約</el-button>
                        </span>
                    </el-dialog>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../../components/Header/Header'
import { mapState } from 'vuex'
import { Message } from 'element-ui'
import $userRepository from '../../backend/userRepository'

export default {
    name: 'favorite-list',
    components: {
        Header
    },
    async created() {
        await this.$store.dispatch('auth/checkAuthed');
    },
    data() {
        return {
            dialogVisible: false,
            circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
        }
    },
    computed: {
        ...mapState({
            user: state => (state.auth.user)
        }),
    },
    methods: {
        // サブスクリプション解約
        async cancel() {
            this.response = await $userRepository.cancel(this.user.id);
            if(this.response.status === 200) {
                Message({
                    message: '解約しました',
                    type: 'success',
                    duration: 0
                });
                location.reload(true);
            }
            // バックエンドで検知したエラーはerrorMessageコンポーネントで表示する
        },
    }
}
</script>

<style scoped>
.wrapper {
    width: 80%;
    display: flex;
    margin: 20px auto;
    justify-content: center;
}

.main {
    width: 95%;
    margin-right: 20px;
    text-align: left;
}

.box-card-content {
    display: flex;
    justify-content: flex-start; /* start */
    align-items: center;
}

.box-card-avatar{
    display: inline-block;
}

.box-card-username{
    display: inline-block;
    padding-left: 15px;
}

.dialog {
    text-align: right;
    font-size: 14px;
}

.dialog-content {
    width: 30%;
    text-align: center;
}

@media screen and (max-width: 1000px) {

    .wrapper {
        width: 90%;
        flex-direction: column-reverse;
    }

    .main {
        width: 100%;
    }

    .box-card-username{
        font-size: 15px;
    }
    
    .box-card-heading{
        font-size: 10px;
    }
    
    .box-card-text{
        font-size: 15px;
    }
}

@media screen and (max-width: 600px) {
    .box-card {
        padding: 0;
    }

    .property-block {
        padding: 1rem 1rem 1rem 1rem;
    }

}
</style>